import { ObjectUtilities, assert, release } from '@awayfl/swf-loader';
import { ABCFile } from './ABCFile';
var ABCCatalog = /** @class */ (function () {
    function ABCCatalog(app, abcs, index) {
        this.app = app;
        this.map = ObjectUtilities.createMap();
        this.abcs = abcs;
        this.scripts = ObjectUtilities.createMap();
        for (var i = 0; i < index.length; i++) {
            var abc = index[i];
            this.scripts[abc.name] = abc;
            release || assert(Array.isArray(abc.defs));
            for (var j = 0; j < abc.defs.length; j++) {
                var def = abc.defs[j].split(':');
                var nameMappings = this.map[def[1]];
                if (!nameMappings) {
                    nameMappings = this.map[def[1]] = Object.create(null);
                }
                nameMappings[def[0]] = abc.name;
            }
        }
    }
    ABCCatalog.prototype.getABCByScriptName = function (scriptName) {
        var entry = this.scripts[scriptName];
        if (!entry) {
            return null;
        }
        var env = { url: scriptName, app: this.app };
        return new ABCFile(env, this.abcs.subarray(entry.offset, entry.offset + entry.length));
    };
    ABCCatalog.prototype.getABCByMultiname = function (mn) {
        var mappings = this.map[mn.name];
        if (!mappings) {
            return null;
        }
        var namespaces = mn.namespaces;
        for (var i = 0; i < namespaces.length; i++) {
            var ns = namespaces[i];
            var scriptName = mappings[ns.uri];
            if (scriptName) {
                return this.getABCByScriptName(scriptName);
            }
        }
        return null;
    };
    return ABCCatalog;
}());
export { ABCCatalog };
